import { render, staticRenderFns } from "./TargetsTab.vue?vue&type=template&id=bc4096bc"
import script from "./TargetsTab.vue?vue&type=script&lang=js"
export * from "./TargetsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports